var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "teacher_theory_wrap" }, [
    true
      ? _c("div", { staticClass: "class_number_statistics" }, [
          _c("h2", [
            _vm._v("班级人数"),
            _c("span", [_vm._v(_vm._s(_vm.overallProgressData.studentNum))]),
            _vm._v("在学人数"),
            _c("span", [_vm._v(_vm._s(_vm.overallProgressData.studyNum))]),
            _vm._v("未学人数"),
            _c("span", [_vm._v(_vm._s(_vm.overallProgressData.noStudyNum))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "class_number_statistics_main" }, [
            _c(
              "div",
              { staticClass: "overall_progress" },
              [
                _c("el-progress", {
                  attrs: {
                    type: "circle",
                    percentage: _vm.overallProgressData.progress,
                    color: "#34D3B0"
                  }
                }),
                _vm._v(" "),
                _c("p", [
                  _vm._v("整体课程进度 "),
                  _c("span", { on: { click: _vm.viewClassProgress } }, [
                    _vm._v("查看详情"),
                    _c("i")
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm.resourceData.length > 0
              ? _c(
                  "div",
                  { staticClass: "classify_progress" },
                  _vm._l(_vm.resourceData, function(item, i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "progress_diagram" },
                      [
                        _c("el-progress", {
                          attrs: {
                            type: "circle",
                            percentage: item.progress ? item.progress : 0
                          }
                        }),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm._f("typeStatus")(item.resourceType)) +
                              "类任务进度"
                          )
                        ])
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e()
          ])
        ])
      : _c(
          "div",
          { staticClass: "class_number_statistics_single" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "overall_course_progress" }, [
              _c("span", [_vm._v("整体课程进度")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    width: "80%",
                    float: "left",
                    margin: "15px 0 0 20px"
                  }
                },
                [
                  _c("el-progress", {
                    attrs: {
                      "show-text": true,
                      "stroke-width": 6,
                      percentage: 70
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("el-button", { on: { click: _vm.viewClassProgress } }, [
              _vm._v("查看详情")
            ])
          ],
          1
        ),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        { staticClass: "recent_learning_num", staticStyle: { width: "100%" } },
        [
          _c("h2", [_vm._v("最近学习人数\n          ")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "broken_line_diagram" },
            [
              _c("p", { on: { click: _vm.tabLearnType } }, [
                _c("b", { class: _vm.learnType == 7 ? "active" : "" }, [
                  _vm._v("周")
                ]),
                _vm._v(" "),
                _c("b", { class: _vm.learnType == 30 ? "active" : "" }, [
                  _vm._v("月")
                ])
              ]),
              _vm._v(" "),
              _c("ve-line", {
                attrs: {
                  data: _vm.learnChartData,
                  settings: _vm.chartSettings,
                  extend: _vm.peopleExtend,
                  width: "98%",
                  height: "350px",
                  "legend-visible": false,
                  colors: _vm.colors
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      false
        ? _c(
            "div",
            { staticClass: "learning_hours_today" },
            [
              _c(
                "el-tabs",
                {
                  attrs: { stretch: true },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.activeName,
                    callback: function($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "今日学习时长排行", name: "first" } },
                    [
                      _c("p", { staticClass: "prompting_language" }, [
                        _vm._v("（包括视频、音频、文档、图片类学习时长）")
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticClass: "ranking_list" }, [
                        _c("li", [
                          _c("span", [
                            _c("img", {
                              attrs: {
                                src: require("../../../../../../../static/images/study/statistics/first.png"),
                                alt: ""
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("1")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("张三")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("10小时24分钟")])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [
                            _c("img", {
                              attrs: {
                                src: require("../../../../../../../static/images/study/statistics/second.png"),
                                alt: ""
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("2")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("张三")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("10小时24分钟")])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [
                            _c("img", {
                              attrs: {
                                src: require("../../../../../../../static/images/study/statistics/third.png"),
                                alt: ""
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("3")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("张三")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("10小时24分钟")])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [
                            _c("img", { attrs: { src: "", alt: "" } })
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("4")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("张三")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("10小时24分钟")])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", [
                            _c("img", { attrs: { src: "", alt: "" } })
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("5")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("张三")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("10小时24分钟")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "view_more",
                          on: { click: _vm.viewLearningDuration }
                        },
                        [_vm._v("查看更多")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "总学习时长排行", name: "second" } },
                    [_vm._v("总学习时长排行")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticStyle: { clear: "both" } }),
    _vm._v(" "),
    _c("div", { staticClass: "discuss_statistics" }, [
      _c("h2", [_vm._v("讨论")]),
      _vm._v(" "),
      _c("div", { staticClass: "class_discuss" }, [
        _c("div", { staticClass: "class_discuss_title" }, [
          _c("h3", [
            _vm._v("班级 "),
            _c("span", { on: { click: _vm.viewClassDiscuss } }, [
              _vm._v("查看详情"),
              _c("i")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "class_discuss_progress" },
          [
            _c("el-progress", {
              attrs: {
                type: "circle",
                percentage: _vm.discussData.departDegress,
                color: "#34D3B0"
              }
            }),
            _vm._v(" "),
            _c("p", [_vm._v("讨论参与度")])
          ],
          1
        ),
        _vm._v(" "),
        _c("ul", { staticClass: "class_discuss_details" }, [
          _c("li", [
            _c("p", [
              _c("span", [
                _vm._v(_vm._s(_vm.discussData.theme_reply_comment_num))
              ]),
              _vm._v("条")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("主题、回复及评论总数")])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", { staticClass: "lis_left" }, [
              _c("p", [
                _c("span", [_vm._v(_vm._s(_vm.discussData.theme_num))]),
                _vm._v("条")
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("主题数")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "lis_right" }, [
              _c("p", [
                _vm._v("老师答疑区主题："),
                _c("span", [_vm._v(_vm._s(_vm.discussData.teacher_theme_num))]),
                _vm._v("条")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("课堂交流区主题："),
                _c("span", [_vm._v(_vm._s(_vm.discussData.student_theme_num))]),
                _vm._v("条")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("p", [
              _c("span", [_vm._v(_vm._s(_vm.discussData.reply_comment_num))]),
              _vm._v("条")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("回复和评论数")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "personal_discuss" }, [
        _c("h3", [_vm._v("个人")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("p", [
              _c("span", [_vm._v(_vm._s(_vm.personalDiscuss.pubThemeNum))]),
              _vm._v("条")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("发布主题数")])
          ]),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("el-progress", {
                attrs: {
                  type: "circle",
                  percentage: _vm.personalDiscuss.replyDegree,
                  color: "#FFB23C"
                }
              }),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "主题回复率（" +
                    _vm._s(_vm.personalDiscuss.replyNum) +
                    "/" +
                    _vm._s(_vm.personalDiscuss.totalReplyNum) +
                    "）"
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("el-progress", {
                attrs: {
                  type: "circle",
                  percentage: _vm.personalDiscuss.departDegree,
                  color: "#5397F7"
                }
              }),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "主题参与率（" +
                    _vm._s(_vm.personalDiscuss.departNum) +
                    "/" +
                    _vm._s(_vm.personalDiscuss.totalDepartNum) +
                    "）"
                )
              ])
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.isTestData
      ? _c("div", { staticClass: "last_wrap" }, [
          _c(
            "div",
            {
              staticClass: "student_open_notes",
              style: "height:" + _vm.testHeight + "px"
            },
            [
              _c("h2", [_vm._v("学生公开笔记")]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c("p", [
                    _c("span", [_vm._v(_vm._s(_vm.noteData.totalNum))]),
                    _vm._v("条")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("公开笔记总数")]),
                  _vm._v(" "),
                  _c("img", {
                    attrs: {
                      src: require("../../../../../../../static/images/study/statistics/arrow.png"),
                      alt: ""
                    },
                    on: {
                      click: function($event) {
                        return _vm.viewPublicNotes("second")
                      }
                    }
                  })
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "test_statistics_wrap",
              attrs: { id: "test_statistics_wrap" }
            },
            [
              _c("div", { staticClass: "test_statistics_diagram" }, [
                _c("h2", [_vm._v("测验")]),
                _vm._v(" "),
                _vm.testChartData.rows.length > 1
                  ? _c(
                      "div",
                      { staticClass: "broken_line_diagram" },
                      [
                        _c("ve-line", {
                          attrs: {
                            data: _vm.testChartData,
                            extend: _vm.testExtend,
                            colors: _vm.testColors,
                            "data-empty": _vm.testDataEmpty,
                            width: "96%",
                            height: "350px"
                          }
                        })
                      ],
                      1
                    )
                  : _c("div", { staticClass: "single_test_diagram" }, [
                      _c("div", [
                        _c("p", [_vm._v(_vm._s(_vm.singleTestData.paperName))]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("完成率"),
                          _c("span", [
                            _vm._v(_vm._s(_vm.singleTestData.progress) + "%")
                          ]),
                          _vm._v(
                            "（提交" +
                              _vm._s(_vm.singleTestData.num) +
                              "人/共" +
                              _vm._s(_vm.singleTestData.studentNum) +
                              "人）"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("ul", [
                        _c(
                          "li",
                          [
                            _c("el-progress", {
                              attrs: {
                                type: "circle",
                                percentage: _vm.singleTestData.maxScore,
                                color: "#FF6464"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.singleTestData.maxScore) + "分")
                            ]),
                            _vm._v(" "),
                            _c("p", [_vm._v("班级最高分")])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c("el-progress", {
                              attrs: {
                                type: "circle",
                                percentage: _vm.singleTestData.avgScore,
                                color: "#B95AFF"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.singleTestData.avgScore) + "分")
                            ]),
                            _vm._v(" "),
                            _c("p", [_vm._v("班级平均分")])
                          ],
                          1
                        )
                      ])
                    ])
              ]),
              _vm._v(" "),
              _vm.testChartData.rows.length > 1
                ? _c("div", { staticClass: "test_statistics_list" }, [
                    _c("h2", [_vm._v("排名")]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      _vm._l(_vm.testDataList, function(item, i) {
                        return _c("li", { key: i }, [
                          _c("p", [_vm._v(_vm._s(item.progress) + "%完成率")]),
                          _vm._v(" "),
                          _c("p", { attrs: { title: item.paperName } }, [
                            _vm._v(_vm._s(item.paperName))
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "( 提交" +
                                _vm._s(item.num) +
                                "人/共" +
                                _vm._s(item.studentNum) +
                                "人 )"
                            )
                          ])
                        ])
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ]
          )
        ])
      : _c("div", [
          _c("div", { staticClass: "student_open_notes_transverse" }, [
            _c("h2", [_vm._v("学生公开笔记")]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _c("p", [
                  _c("span", [_vm._v(_vm._s(_vm.noteData.totalNum))]),
                  _vm._v("条")
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("公开笔记总数")]),
                _vm._v(" "),
                _c("img", {
                  attrs: {
                    src: require("../../../../../../../static/images/study/statistics/arrow.png"),
                    alt: ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.viewPublicNotes("second")
                    }
                  }
                })
              ])
            ])
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _vm._v("班级人数"),
      _c("span", [_vm._v("60")]),
      _vm._v("在学人数"),
      _c("span", [_vm._v("45")]),
      _vm._v("未学人数"),
      _c("span", [_vm._v("15")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dda1577", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dda1577","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/statistics/teacher/teacherTheory.vue
// module id = null
// module chunks = 